import React, { useState, useEffect } from "react";
import { Row, Col, FormGroup, Label, Input, FormFeedback } from "reactstrap";
import FieldWrapper from "../../commons/FieldWrapper";

const ProfileCustomQuestions = ({ questions, answers, onChange, wasSubmitted }) => {
  const [fields, setFields] = useState([]);

  useEffect(() => {
    setFields(
      questions.map((q) => ({
        ...q,
        value: answers[q.id] || "",
        errors: q.errors || []
      }))
    );
  }, [questions, answers]);

  const handleInputChange = (id, value) => {
    setFields((fields) =>
      fields.map((f) => (f.id === id ? { ...f, value } : f))
    );
    onChange(id, value);
  };

  return (
    <div>
      <hr />
      <h3 className="h6 font-weight-bold mb-3">
        <i className="fas fa-question-circle me-2"></i>
        Preguntas adicionales
      </h3>
      <Row>
        {fields.map((field) => (
          <Col md="12" key={field.id} className="mb-3">
            <FormGroup>
              <Label>
                {field.name}
                {field.required && <span className="text-danger ms-1">*</span>}
              </Label>
              <FieldWrapper errors={field.errors || []}>
                {field.answer_type === "boolean" ? (
                  <Input
                    type="select"
                    value={field.value}
                    invalid={!!(field.errors && field.errors.length > 0)}
                    onChange={(e) => handleInputChange(field.id, e.target.value)}
                  >
                    <option value="">Selecciona...</option>
                    <option value="true">Sí</option>
                    <option value="false">No</option>
                  </Input>
                ) : field.answer_type === "number" ? (
                  <Input
                    type="number"
                    value={field.value}
                    invalid={!!(field.errors && field.errors.length > 0)}
                    onChange={(e) => handleInputChange(field.id, e.target.value)}
                  />
                ) : field.answer_type === "textarea" || field.answer_type === "textarea" ? (
                  <Input
                    type="textarea"
                    value={field.value}
                    invalid={!!(field.errors && field.errors.length > 0)}
                    onChange={(e) => handleInputChange(field.id, e.target.value)}
                  />
                ) : (
                  <Input
                    type="text"
                    value={field.value}
                    invalid={!!(field.errors && field.errors.length > 0)}
                    onChange={(e) => handleInputChange(field.id, e.target.value)}
                  />
                )}
                {(field.errors && field.errors.length > 0) && (
                  <FormFeedback className="d-block">
                    {field.errors.map((err, idx) => (
                      <span key={idx}>{err}</span>
                    ))}
                  </FormFeedback>
                )}
                {field.required && !field.value && wasSubmitted && (!field.errors || field.errors.length === 0) && (
                  <FormFeedback className="d-block">
                    Debe completar los datos para avanzar
                  </FormFeedback>
                )}
              </FieldWrapper>
            </FormGroup>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default ProfileCustomQuestions;
